import { useContext, useState } from "react";
import { KeyedMutator } from "swr";
import { BaseContext } from "~context/baseContext";
import {
  CalculateTicketCoverAmountsQuery,
  OrderQuery,
  UpdateOrderTicketCoverInput,
} from "~graphql/sdk";
import {
  getGraphQLError,
  handlePromise,
  SDKGeneratorFn,
  showToast,
} from "~lib";

export const useTicketCover = (recaptchaSdkGenerator: SDKGeneratorFn) => {
  const [
    ticketCoverAmount,
    setTicketCoverAmount,
  ] = useState<CalculateTicketCoverAmountsQuery>();
  const { organization } = useContext(BaseContext);

  const calculateTicketCoverPrice = async (
    order: OrderQuery["order"],
    total?: number
  ) => {
    const sdkFn = await recaptchaSdkGenerator("calculateTicketCoverAmounts");
    const { error, data } = await handlePromise(
      async () =>
        await sdkFn({ orgId: organization.id }).calculateTicketCoverAmounts({
          id: order.id,
          total,
        })
    );

    if (error) {
      const e = getGraphQLError(error);
      showToast(e.message, "error");
      return 0;
    }

    setTicketCoverAmount(data);

    return data.calculateTicketCoverAmounts.totalFeeAmount;
  };

  const updateTicketCover = async (
    order: OrderQuery["order"],
    update: UpdateOrderTicketCoverInput,
    mutate: KeyedMutator<OrderQuery["order"]>
  ) => {
    const sdkFn = await recaptchaSdkGenerator("updateTicketCoverForOrder");
    const { error } = await handlePromise(async () =>
      sdkFn({ orgId: organization?.id }).updateTicketCoverForOrder({
        id: order?.id,
        input: { ...update },
      })
    );

    if (error) {
      const e = getGraphQLError(error);
      return showToast(e.message, "error");
    }

    void mutate(
      {
        ...order,
      },
      true
    );
  };

  return { calculateTicketCoverPrice, ticketCoverAmount, updateTicketCover };
};
